import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';

//iconos
import { Add, BeenhereRounded } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//servicios
import { wsFindBy, wsGet } from 'services/WService.js';

//modal
import Modal from './Modal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import ButtonDelete from 'hooks/ButtonDelete';
import { useModal } from 'hooks/useModal';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Concepto', accessor: 'pymt_concept_description' },
  { Header: 'Centro costo', accessor: 'pymt_expense_center_description' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function AccountConcept(props) {
  const classes = useStyles();
  const { id } = useParams();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [account, setAccount] = useState({}); //notificación despues de las acciones
  const [accountConcepts, setAccountConcepts] = useState([]); //constante para el listado

  async function getAccount(idAccount) {
    let response = await wsGet('pymt/account', idAccount);
    if (response.success) {
      setAccount(response.data);
    }
  }

  async function listAccountConcepts() {
    let response = await wsFindBy('pymt/account-concept', { pymt_account_id: id });
    if (response.success) setAccountConcepts(response.data);
  }

  useEffect(() => {
    getAccount(id);
    listAccountConcepts();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listAccountConcepts}
          idConcept={id}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PYMT_ACCOUNT_CONCEPTS_STORE}
              component={
                <CardIcon color={props.themeContext.buttonColor}>
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Listado de concepto de la cuenta
              <span style={{ fontSize: '14px' }}>
                <b>{` (${account.account} - ${account.description || ''})`}</b>
              </span>
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Concepto-de-cuenta"
              defaultWidth={1000}
              columns={columns}
              data={accountConcepts.map((item, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PYMT_ACCOUNT_CONCEPTS_DELETE}>
                        <ButtonDelete
                          entity="pymt/account-concept"
                          id={item.id}
                          reload={listAccountConcepts}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  pymt_concept_description: item.pymt_concept_description,
                  pymt_expense_center_description: item.pymt_expense_center_description,
                  base_zone_description: item.base_zone_description,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
